import { Checkbox } from '@ibsys/kit';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { BlockResponse, RuleResponse } from '@/entities/expert-report';
import type { RuleWithPath } from './types';

type RuleCheckboxItemProps = {
  rule: RuleResponse;
  block: BlockResponse;
  reportId: number;
  reportName: string;
  blockPath: string[];
  isLinked: boolean;
  isSelected: boolean;
  onToggle: (rule: RuleWithPath) => void;
  depth: number;
};

export const RuleCheckboxItem: FC<RuleCheckboxItemProps> = ({
  rule,
  block,
  reportId,
  reportName,
  blockPath,
  isLinked,
  isSelected,
  onToggle,
  depth,
}) => {
  const { t } = useTranslation('coaching');

  const ruleData: RuleWithPath = useMemo(
    () => ({
      id: rule.id,
      name: rule.name,
      text: rule.text,
      expertReportBlockId: block.id,
      expertReportBlockName: block.name,
      expertReportId: reportId,
      expertReportName: reportName,
      blockPath,
    }),
    [rule, block, reportId, reportName, blockPath],
  );

  const paddingLeft = (depth + 2) * 16;

  return (
    <div className="py-0.5" style={{ paddingLeft: `${paddingLeft}px` }}>
      <Checkbox
        label={isLinked ? `${rule.name} (${t('alreadyLinked')})` : rule.name}
        value={isLinked || isSelected}
        disabled={isLinked}
        onChange={() => onToggle(ruleData)}
      />
    </div>
  );
};
